import React from 'react';

const CharityCounterPending = () => (
    <div className={'charity-counter-box pending'}>
        <div className={'counter wave-animation'} />
    </div>
);

export default CharityCounterPending;
